/** Tokens motion — register « éditorial » aligné vitrine (signature easing, tempo lent). */

export const EASE_OUT_QUINT = [0.25, 0.75, 0.25, 1];

/** @type {Record<string, import('framer-motion').Transition>} */
export const MOTION = {
  /** Retour tactile, toggles */
  fast: { duration: 0.2, ease: EASE_OUT_QUINT },
  /** Changement d’état, onglets, toasts */
  medium: { duration: 0.3, ease: EASE_OUT_QUINT },
  /** Modales, panneaux */
  panel: { duration: 0.5, ease: EASE_OUT_QUINT },
};

/**
 * @param {boolean} reduced
 * @param {'fast' | 'medium' | 'panel'} key
 */
export function transition(reduced, key = 'medium') {
  return reduced ? { duration: 0 } : MOTION[key];
}

/** Entrée feuille mobile (modale bas d’écran). */
export const sheetVariants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 10 },
};

/** Contenu d’onglet / section. */
export const panelVariants = {
  initial: { opacity: 0, y: 6 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
};

/** Toast / bannière feedback. */
export const toastVariants = {
  initial: { opacity: 0, y: -10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -6 },
};

/** Overlay fond modal. */
export const overlayVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};
